import axios from 'axios';
import Cookies from 'universal-cookie';

import appConfig from '../config/app.config';

const cookies = new Cookies();

const instance = axios.create({
  baseURL: appConfig.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(
  function (config) {
    if (config.headers['Content-Type'] !== 'application/json') return config;

    const accessToken = cookies.get('access_token');
    if (accessToken) {
      // add the authorization to the headers
      const headers = config.headers;
      headers['Authorization'] = 'Bearer ' + accessToken;

      config.headers = headers;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default instance;
